import { IAction } from '..';
import { TaskIcon, TaskTheme } from '../../../shared/types';

export interface IBuilderTask {
    id: string;
    icon: TaskIcon;
    miles: number;
    shortTitle: string;
    price: number;
    length: number;
    themes: {
        id: string;
        theme: TaskTheme;
        value: number;
    }[];
    description: string | null;
    shortDescription: string | null;
    learningCoachFeedback: boolean;
    isGroupTask: boolean;
    isMedia: boolean;
    isPeopleEvent: boolean;
    isLecture: boolean;
}

export interface IBuilderState {
    loading: boolean;
    name: string;
    tasks: IBuilderTask[];
    modalTask: IBuilderTask | null;
    modalIndex: number | null;
    showThemes: boolean;
    showMiles: boolean;
    showLength: boolean;
    showPrice: boolean;
}

const initialState: IBuilderState = {
    loading: true,
    name: '',
    tasks: [],
    modalTask: null,
    modalIndex: null,
    showThemes: false,
    showMiles: false,
    showLength: false,
    showPrice: false,
};

export function reducer(state: IBuilderState = initialState, action: IAction): IBuilderState {
    let tasks: IBuilderTask[];
    let task: IBuilderTask;
    let modalIndex: number;
    switch (action.type) {
        case 'INIT_EMPTY_BUILDER_PATH':
            return {
                ...state,
                name: action.name,
                showThemes: false,
                showMiles: false,
                showLength: false,
                showPrice: false,
                tasks: [],
                loading: false,
            };
        case 'INIT_BUILDER_PATH':
            return {
                ...state,
                name: action.name,
                showThemes: action.showThemes,
                showMiles: action.showMiles,
                showLength: action.showLength,
                showPrice: action.showPrice,
                tasks: action.tasks,
                loading: false,
            };
        case 'SET_MODAL_TASK':
            return {
                ...state,
                modalTask: action.task,
                modalIndex: action.index,
            };
        case 'ADD_TASK_TO_PATH':
            if (action.where === 'start') {
                tasks = [action.task, ...state.tasks];
            } else {
                tasks = [...state.tasks, action.task];
            }
            return {
                ...state,
                tasks,
            };
        case 'ADD_TASK_TO_PATH_AT_INDEX':
            tasks = [...state.tasks];
            tasks.splice(action.index, 0, action.task);
            return {
                ...state,
                tasks,
            };
        case 'REMOVE_TASK_FROM_PATH':
            tasks = [...state.tasks];
            tasks.splice(action.index, 1);
            return {
                ...state,
                tasks,
            };
        case 'MOVE_TASK_ON_PATH':
            tasks = [...state.tasks];
            modalIndex = state.modalIndex;
            [task] = tasks.splice(action.index, 1);
            if (action.target === 'start') {
                tasks.unshift(task);
                modalIndex = 0;
            } else if (action.target === 'end') {
                tasks.push(task);
                modalIndex = tasks.length - 1;
            } else {
                if (action.target < 0) {
                    tasks.splice(0, 0, task);
                    modalIndex = 0;
                } else {
                    tasks.splice(action.target, 0, task);
                    modalIndex = Math.min(action.target, tasks.length - 1);
                }
            }
            return {
                ...state,
                modalIndex,
                tasks,
            };
        case 'UPDATE_PATH_NAME':
            return {
                ...state,
                name: action.name,
            };
        case 'TOGGLE_SHOW_THEMES':
            return {
                ...state,
                showThemes: action.to,
            };
        case 'TOGGLE_SHOW_MILES':
            return {
                ...state,
                showMiles: action.to,
            };
        case 'TOGGLE_SHOW_LENGTH':
            return {
                ...state,
                showLength: action.to,
            };
        case 'TOGGLE_SHOW_PRICE':
            return {
                ...state,
                showPrice: action.to,
            };
        default:
            return state;
    }
}
